import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {fromEvent} from 'rxjs';
import {throttleTime} from 'rxjs/operators';

@Component({
  selector: 'gg-volume-bar',
  templateUrl: './volume-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VolumeBarComponent implements OnInit {
  @Input() volume: number;
  @Output() toggleMute = new EventEmitter();
  @Output() setVolume = new EventEmitter<number>();
  @ViewChild('volumeRange') volumeRange: ElementRef;

  constructor() {
  }

  ngOnInit() {
    fromEvent(this.volumeRange.nativeElement, 'input')
      .pipe(throttleTime(15))
      .subscribe(() => this.setVolume.emit(this.volumeRange.nativeElement.value));
  }

  muteClick() {
    this.toggleMute.emit();
  }

}
